import React, { useEffect, useState, useContext } from 'react'
import StockInListHeader from './StockInListHeader'
import StockInListInner from './StockInListInner'
import StockInListFooter from './StockInListFooter'
import { appContext } from '../../../App'
import { getWarehouses, getStockInByID, getStockInList,
  getStockInSettings, saveStockInSettings, deleteStockIn } from '../StockInFunctions'

export const stockInListControllerContext = React.createContext()

function useStockInListController() {
  const app = useContext(appContext)
  const [warehouse, setWarehouse] = useState(null)
  const [warehouses, setWarehouses] = useState(null)
  const [recordPerPage, setRecordPerPage] = useState(0)
  const [recPP, setRecPP] = useState(0)
  const [page, setPage] = useState(1)
  const [totalPage, setTotalPage] = useState(0)
  const [stockInList, setStockInList] = useState([])
  const [stockInSettings, setStockInSettings] = useState(null)
  const [startSlice, setStartSlice] = useState(0)
  const [endSlice, setEndSlice] = useState(0)
  const [stockInListSorted, setStockInListSorted] = useState(false)
  const [sortBy, setSortBy] = useState(null)
  const [filter, setFilter] = useState({})
  const [foundUnpostedSI, setFoundUnpostedSI] = useState(null)
  const [selectAll, setSelectAll] = useState(null)
  const [selectedSIId, setSelectedSIId] = useState([])

  const updateSISettings = async (date, footer) => {
    if (footer.record_per_page === '' || footer.record_per_page === 0) {
      footer.record_per_page = 25 // If record_per_page is invalid then set it 25 as default
    }
    const si_settings = await saveStockInSettings(app, date, footer)
    if (si_settings) {
      setFilter({date: date})
      setStockInSettings({ date, footer })
      setRecordPerPage(footer.record_per_page)
      setRecPP(footer.record_per_page)
    } else return si_settings // save settings is not successful
  }

  const getTotalRecords = () => stockInList.length

  const sortStockInListBy = (column) => {
    const sortByDateTimeCreated = () => {
      stockInList.sort((a, b) => {
        let sorted
        if (!stockInListSorted)
          sorted = ((new Date(a.date_time_created).getTime()) - (new Date(b.date_time_created).getTime()))
        else
          sorted = ((new Date(b.date_time_created).getTime()) - (new Date(a.date_time_created).getTime()))
        return sorted
      })
    }

    const sortByDateReceived = () => {
      stockInList.sort((a, b) => {
        let sorted
        if (!stockInListSorted)
          sorted = ((new Date(a.date_received).getTime()) - (new Date(b.date_received).getTime()))
        else
          sorted = ((new Date(b.date_received).getTime()) - (new Date(a.date_received).getTime()))
        return sorted
      })
    }

    const sortByDestinationWarehouse = () => {
      stockInList.sort((a, b) => {
        let x, y
        if (!stockInListSorted) {
          x = a.warehouse.name.toLowerCase()
          y = b.warehouse.name.toLowerCase()
        } else {
          x = b.warehouse.name.toLowerCase()
          y = a.warehouse.name.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByReceivedBy = () => {
      stockInList.sort((a, b) => {
        let x, y
        if (!stockInListSorted) {
          x = a.received_by.toLowerCase()
          y = b.received_by.toLowerCase()
        } else {
          x = b.received_by.toLowerCase()
          y = a.received_by.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByReferenceCode = () => {
      stockInList.sort((a, b) => {
        let x, y
        if (!stockInListSorted) {
          x = a.reference_code.toLowerCase()
          y = b.reference_code.toLowerCase()
        } else {
          x = b.reference_code.toLowerCase()
          y = a.reference_code.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortBySupplierName = () => {
      stockInList.sort((a, b) => {
        let x, y
        if (!stockInListSorted) {
          x = a.supplier_name.toLowerCase()
          y = b.supplier_name.toLowerCase()
        } else {
          x = b.supplier_name.toLowerCase()
          y = a.supplier_name.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByStatus = () => {
      stockInList.sort((a, b) => {
        let x, y
        if (!stockInListSorted) {
          x = a.status.toLowerCase()
          y = b.status.toLowerCase()
        } else {
          x = b.status.toLowerCase()
          y = a.status.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    switch (column) {
      case 'date_time_created': sortByDateTimeCreated()
        break
      case 'date_received': sortByDateReceived()
        break
      case 'destination_warehouse': sortByDestinationWarehouse()
        break
      case 'received_by': sortByReceivedBy()
        break
      case 'reference_code': sortByReferenceCode()
        break
      case 'supplier_name': sortBySupplierName()
        break
      case 'status': sortByStatus()
        break
      default:
    }

    setStockInListSorted(!stockInListSorted)
    setStockInList(stockInList)
  }

  const filterStockInList = async (searchString) => {
    // Get the lates stockInList
    const stockin_list = await getStockInList(app, filter)
    let tempStockInList = []

    // Create products item_full_description element on productsCopy object on-the-fly
    if (warehouse._id !== 0 ) {
      stockin_list.filter(si => si.warehouse.id === warehouse._id).forEach((stockin_item, i) => {
          stockin_item.item_full_description = `${stockin_item._id} ${stockin_item.warehouse.name} ${stockin_item.received_by} ${stockin_item.reference_code} ${stockin_item.supplier_name} ${stockin_item.remarks} ${stockin_item.status}`
      })

      stockin_list.filter(si => si.warehouse.id === warehouse._id).forEach(stockin_item => {
        let found = true
        searchString.split(' ').forEach((search_string_item, i) => {
          found = (found && (stockin_item.item_full_description.toLowerCase().search(search_string_item.toLowerCase()) !== -1))
        })
        if (found) tempStockInList.push(stockin_item)
      })
    } else {
      stockin_list.forEach((stockin_item, i) => {
          stockin_item.item_full_description = `${stockin_item._id} ${stockin_item.warehouse.name} ${stockin_item.received_by} ${stockin_item.reference_code} ${stockin_item.supplier_name} ${stockin_item.remarks} ${stockin_item.status}`
      })

      stockin_list.forEach(stockin_item => {
        let found = true
        searchString.split(' ').forEach((search_string_item, i) => {
          found = (found && (stockin_item.item_full_description.toLowerCase().search(search_string_item.toLowerCase()) !== -1))
        })
        if (found) tempStockInList.push(stockin_item)
      })
    }

    setStockInList(tempStockInList)

    reloadStockInList(false) // reload/reset some variables except the stockInList
  }

  const batchDeleteSelectedSI = async () => {
    // Since this is batch delete, I decide to no not catch individual errors when deleting each stockin
    for (let id of selectedSIId) await deleteStockIn(app, id)

    reloadStockInList()
  }

  const setAllCheck = (check) => {
    const siCheckBoxes = document.querySelectorAll('.si-checkbox')
    let tempSIIdList = []

    // Reset the list
    setSelectedSIId([])

    // First checked all checkbox that is not checked
    siCheckBoxes.forEach((checkBox, i) => {
      const siId = checkBox.closest('.si-item').id
      if (check) tempSIIdList.push(siId)
      checkBox.checked = check
    })

    setSelectedSIId(tempSIIdList)
  }

  const addSelectedSIId = (si_id) => {
    setSelectedSIId([...selectedSIId, si_id])
  }

  const removeSelectedSIId = (si_id) => {
    setSelectedSIId(selectedSIId.filter((id) => id !== si_id))
  }

  const reloadStockInList = async (full=true) => {
    if (full) {
      const si_list = await getStockInList(app, filter)
      if (warehouse?._id) setStockInList(si_list.filter(si => si.warehouse.id === warehouse._id))
      else setStockInList(si_list)
    }

    setAllCheck(false)
    setSelectAll(false)
    setSortBy(null)
    setSelectedSIId([])
    setPage(1)
  }

  useEffect(() => {
    let isMounted = true

    const init = async () => {
      const whs = await getWarehouses(app)
      const si_settings = await getStockInSettings(app)

      if (isMounted) {
        setWarehouses([{name: '--All--', _id: 0}, ...whs])
        setWarehouse({name: '--All--', _id: 0})
        setFilter({...filter, date: si_settings.date})
        setStockInSettings(si_settings)
        setRecordPerPage(si_settings.footer.record_per_page)
        setRecPP(si_settings.footer.record_per_page)
      }
    }

    if (isMounted) init()

    return (() => { isMounted = false })
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (warehouse && stockInSettings) reloadStockInList()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [warehouse, stockInSettings])

  useEffect(() => { setAllCheck(selectAll) }, [selectAll])

  useEffect(() => {
    // set total page
    setTotalPage(Math.ceil(getTotalRecords() / recordPerPage))

    // slice stockinlist
    setStartSlice((page - 1) * recordPerPage)
    setEndSlice(page * recordPerPage)

    if (stockInList) setFoundUnpostedSI( stockInList.find( si => (si.status === 'Unposted') ) )

    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordPerPage, stockInList, page])

  return ({
    stockInList: stockInList,
    stockInSettings: [stockInSettings, setStockInSettings],
    startSlice: [startSlice, setStartSlice],
    endSlice: [endSlice, setEndSlice],
    recordPerPage: [recordPerPage, setRecordPerPage],
    recPP: [recPP, setRecPP],
    page: [page, setPage],
    warehouse: [warehouse, setWarehouse],
    selectAll: [selectAll, setSelectAll],
    sortBy: [sortBy, setSortBy],
    batchDeleteSelectedSI,
    addSelectedSIId,
    removeSelectedSIId,
    selectedSIId,
    foundUnpostedSI,
    warehouses,
    getTotalRecords,
    totalPage,
    reloadStockInList,
    updateSISettings,
    sortStockInListBy,
    filterStockInList,
    stockInListSorted,
    getStockInByID
  })
}

function StockInListController() {
  const stockInListController = useStockInListController()
  return (
    <React.Fragment>
      <stockInListControllerContext.Provider value={stockInListController}>
        <StockInListHeader />
        <StockInListInner />
        <StockInListFooter />
      </stockInListControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(StockInListController)